<template>
    <toast>
        <template #container="{message, closeCallback}">
            <toast-container :close-callback="closeCallback" :message="message" />
        </template>
    </toast>
</template>

<script setup>
import Toast from 'primevue/toast';
import ToastContainer from './ToastContainer.vue';
</script>
